export default __webpack_public_path__ + "haalfashion-colored.png";